import { noop } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

// Zocdoc dependencies
import { Arrow } from '@zocdoc-frontend-common/assets-icons';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { white } from '@zocdoc/branding/colors';

export const LinkFarmToggle = props => {
    return (
        <StyledToggle
            toggleState={props.toggleState}
            onClick={props.onToggleClick}
        >
            <ToggleLink data-test="footer-toggle-link">
                {props.toggleText}
            </ToggleLink>
            <StyledArrow
                data-test="styled-arrow"
                direction={props.toggleState ? 'up' : 'down'}
                color="currentColor"
            />
        </StyledToggle>
    );
};

LinkFarmToggle.propTypes = {
    toggleText: PropTypes.string,
    toggleState: PropTypes.bool,
    onToggleClick: PropTypes.func,
};

LinkFarmToggle.defaultProps = {
    toggleText: '',
    toggleState: false,
    onToggleClick: noop,
};

const StyledToggle = styled.span`
    display: inline-block;
    cursor: pointer;
    font: 15px/2.6 ${FontFamily.SharpSansSemibold};
    padding: 0 0 0 16px;
    color: ${p => (p.toggleState ? white : 'rgba(255, 255, 255, 0.6)')};

    ${breakpoint.medium} {
        font-size: 14px;
        line-height: 1.4;
        padding: 0;
        color: ${p =>
            p.toggleState
                ? p.theme.footer.legal.linkColorHover
                : p.theme.footer.legal.linkColor};

        &:hover {
            color: ${p => p.theme.footer.legal.linkColorHover};
        }
    }
`;

export const ToggleLink = styled.span`
    margin-right: 0 !important;
`;

export const StyledArrow = styled(Arrow)`
    margin-left: 6px;
    font: 6px ${FontFamily.SharpSansSemibold};
    margin-bottom: 2px;
`;
